
import MDEditor from '@uiw/react-md-editor';

const MarkDown = (props: any) => {
    const { value, setValue, height } = props;
    return (
        <div>
            <MDEditor
            value={value}
            onChange={setValue}
            height={height}
            />
        </div>
    )
}

export default MarkDown;